import { Table, TableWrapper, Tbody, Td, Th, Thead, Tr } from '@components/core-ui/Table';
import { Header } from '@components/Header';
import TrashBin from '@components/icons/TrashBin.svg';
import { LinearProgressLoader } from '@components/core-ui/spinners/LinearProgressLoader';

import { Tabs } from '@pages/Admin/SMSCountries/components/Content/components/Tabs';
import { useModalContext } from '@providers/ModalProvider';
import { useAPI } from '@providers/useAPI';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { SmsWhitelistService } from 'app/API';
import { smsKeys } from 'app/queries/sms/smsKeys';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { createFetchSmsWhitelistQueryFn } from '../../api/fetchSmsWhitelist';
import { CellContent } from './styles/CellContent';
import { IconButtonDelete } from '@components/core-ui/form-elements/buttons/IconButton/variations/IconButtonDelete';
import { Wrapper } from './styles/Wrapper';

export const Content = () => {
  const { call } = useAPI();
  const queryClient = useQueryClient();
  const { openModal, closeModal } = useModalContext();

  const whitelistQuery = useQuery({
    queryKey: smsKeys.whitelist(),
    queryFn: createFetchSmsWhitelistQueryFn(call),
  });

  const removeMutation = useMutation({
    mutationFn: (number: string) => call(() => SmsWhitelistService.remove({ number })),
    onSettled: () => queryClient.invalidateQueries({ queryKey: smsKeys.whitelist() }),
  });

  const createWhitelist = () => {
    openModal(ModalNamesEnum.CreateNewWhitelistNumber, {
      onSuccess: () => {
        closeModal();
        void queryClient.invalidateQueries({ queryKey: smsKeys.whitelist() });
      },
    });
  };

  const removeWhitelist = (number: string) => {
    const confirmation = window.confirm('Are you sure you want to remove this whitelisted number?');

    if (!confirmation) {
      return;
    }
    removeMutation.mutate(number);
  };

  const smsWhitelist = whitelistQuery.data ?? [];
  const isLoading = whitelistQuery.isFetching || removeMutation.isPending;

  return (
    <>
      <Header
        title={'SMS Phone number whitelist'}
        buttonLabel={'Add new phone number'}
        buttonOnClick={() => createWhitelist()}
        leftSideContent={[<Tabs key="SMSTabs" currentTab="SMS Whitelist" />]}
      />

      <LinearProgressLoader active={isLoading} />
      <Wrapper>
        <TableWrapper>
          <Table>
            <Thead>
              <Tr>
                <Th>#</Th>
                <Th>Number</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {smsWhitelist.map((data, index) => (
                <Tr key={data.number}>
                  <Td>
                    <CellContent>{index + 1}</CellContent>
                  </Td>
                  <Td>
                    <CellContent>{data.number}</CellContent>
                  </Td>
                  <Td>
                    <CellContent>
                      <IconButtonDelete title="Remove" onClick={() => removeWhitelist(data.number)}>
                        <TrashBin />
                      </IconButtonDelete>
                    </CellContent>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableWrapper>
      </Wrapper>
    </>
  );
};
